export default __webpack_public_path__ + "static/media/Untitled-1-Recoveredert.3f1d4da2.png";